import type { Column } from '@tanstack/react-table'
import type { CSSProperties } from 'react'

export function getColumnPinningStyles<TData>(
  column: Column<TData, unknown>,
  options?: { isHeader?: boolean },
): CSSProperties {
  const isPinned = column.getIsPinned()
  if (!isPinned) return {}

  const isLastLeftPinnedColumn =
    isPinned === 'left' && column.getIsLastColumn('left')
  const isFirstRightPinnedColumn =
    isPinned === 'right' && column.getIsFirstColumn('right')

  return {
    position: 'sticky',
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    width: column.getSize(),
    zIndex: options?.isHeader ? 20 : 10,
    boxShadow: isLastLeftPinnedColumn
      ? 'inset -4px 0 4px -4px hsl(var(--border) / 0.8)'
      : isFirstRightPinnedColumn
        ? 'inset 4px 0 4px -4px hsl(var(--border) / 0.8)'
        : undefined,
  }
}

/** Pinned cells need opaque backgrounds so scrolled columns don't show through on hover. */
export function getDataTableCellClassName<TData>(
  pinEnabled: boolean,
  column?: Column<TData, unknown>,
  options?: { isHeader?: boolean },
): string {
  if (!pinEnabled) return ''

  const isPinned = Boolean(column?.getIsPinned())
  if (isPinned) {
    return options?.isHeader
      ? 'bg-card'
      : 'bg-card group-hover/row:bg-muted group-data-[state=selected]/row:bg-muted'
  }

  if (options?.isHeader) return ''
  return 'group-hover/row:bg-muted/50 group-data-[state=selected]/row:bg-muted'
}
